import * as types from 'models/actionTypes'
import { openComposition } from 'models/compositions/actions'
import * as scenesApi from 'services/scenes'

const checkManifest = (manifest) =>
    manifest && manifest.pano_0 && manifest.plane_orientation_0 && manifest.normals_segmentation_0

const requestScenes = () => ({
    type: types.REQUEST_SCENES,
})

// Notify that scenes has been fetched
const receiveScenes = (scenes) => ({
    type: types.RECEIVE_SCENES,
    scenes,
})

const failedReceiveScenes = () => ({
    type: types.FAILED_RECEIVE_SCENES,
})

const requestScene = (id) => ({
    type: types.REQUEST_SCENE,
    id,
})

const receiveScene = (scene) => ({
    type: types.RECEIVE_SCENE,
    scene,
})

const failedReceiveScene = () => ({
    type: types.FAILED_RECEIVE_SCENE,
})

export const selectScene = (id) => ({
    type: types.SELECT_SCENE,
    id,
})

export const openScene =
    (id, trackingInfo = {}) =>
    (dispatch) => {
        dispatch(selectScene(id))
        dispatch(openComposition(-1, trackingInfo))
    }

export const fetchScene = (id) => (dispatch) => {
    dispatch(requestScene(id))
    return scenesApi
        .getScene(id)
        .then(({ data: scene }) => {
            if (checkManifest(scene.manifest)) {
                dispatch(receiveScene(scene))
            } else {
                dispatch(failedReceiveScene())
            }
        })
        .catch(() => {
            dispatch(failedReceiveScene())
        })
}

// Fetch and dispatch with results
export const fetchScenes =
    (isRetry = false) =>
    (dispatch) => {
        dispatch(requestScenes())

        return scenesApi
            .getScenes()
            .then(({ data }) => {
                // Remove scenes with invalid manifests (just in case)
                const scenes = data.filter((s) => checkManifest(s.manifest))
                dispatch(receiveScenes(scenes))
            })
            .catch(() => {
                if (!isRetry) {
                    dispatch(fetchScenes(true))
                } else {
                    dispatch(failedReceiveScenes())
                }
            })
    }

export const updateSceneManifest = (id, key, value) => ({
    type: types.UPDATE_SCENE_MANIFEST,
    id,
    key,
    value,
})
